import { TResponse, TTotal } from "@/module/common"
import { TRecordListType, TRecordMenuType, TUserCurrType } from '@/module/record';
import { getRecordList, getRecordMenu,getUserCurriculum } from "@/api/record";
import { ref } from "vue";
import { ElLoading } from 'element-plus'
function dataInit() {
    const recordMenu = ref<TRecordMenuType[]>()
    const gradeList = ref<TRecordMenuType[]>()
    const isShow=ref(false)

    // 获取章节接口
    async function GetRecordMenu(Id: any, rank: number, Type: number): Promise<TRecordMenuType[]> {
        return new Promise(async (resolve, reject) => {
            let res: TResponse<TRecordMenuType[]> = await getRecordMenu({ ParentId: Id, ChildrenCount: rank, Type: Type })
            let { Code, Data } = res
            if (Code === 200) {
                if (rank === 1) {
                    recordMenu.value = Data
                    resolve(recordMenu.value)
                } else if (rank === 2) {
                    gradeList.value = Data
                    resolve(gradeList.value)
                } else {
                    gradeList.value = Data
                    resolve(gradeList.value)
                }
            }
        })
    }
    // 获取录播列表
    const GetRecordList = async (item: any, Id: number, Type: number) => {
        isShow.value = false
        const loading = ElLoading.service({
            lock: true,
            text: 'Loading',
            background: 'rgba(0, 0, 0, 0)'
        })
        try {
            let res: TResponse<TTotal<TRecordListType[]>> = await getRecordList({ Id: Id, PageIndex: item.PageIndex, PageSize: item.PageSize, Type: Type })
            let { Code, Data } = res
            if (Code === 200) {
                item.list = Data.Data
                item.total = Data.Total
                if (item.list.length===0){
                   isShow.value = true
                }
            }
        } catch (error) {

        }finally{
            loading.close()
        }
    }
    // 获取首页录播列表
    const GetUserCurriculum = async (item: any, Type:number) => {
        isShow.value = false
        const loading = ElLoading.service({
            lock: true,
            text: 'Loading',
            background: 'rgba(0, 0, 0, 0)'
        })
        try {
            let res: TResponse<TTotal<TUserCurrType[]>> = await getUserCurriculum({ PageIndex: item.PageIndex, PageSize: item.PageSize, Type: Type })
            let { Code, Data } = res
            if (Code === 200) {
                item.list = Data.Data
                item.total = Data.Total
                if (item.list.length===0){
                   isShow.value = true
                }
            }
        } catch (error) {

        }finally{
            loading.close()
        }
    }
    return {
        recordMenu,
        gradeList ,
        isShow,
        GetRecordList,
        GetRecordMenu,
        GetUserCurriculum
    }
}
export default dataInit